module.exports = __webpack_public_path__ + "static/media/Subtle-Prism.80f3d59c.svg";